import { AdvancedMarker } from '@vis.gl/react-google-maps'
import tripOrigin from '@/assets/images/trip_origin.png'
import type { LatLng } from '@/types/structs'

/* MarkerId("current"): trip_origin.png rendered 24x24, anchor (0.5, 0.5).
 * AdvancedMarker anchors content at bottom-centre; translateY(50%) moves the
 * image so its CENTRE sits on the coordinate. */

export function CurrentMarker({ position }: { position: LatLng }) {
  return (
    <AdvancedMarker position={position} zIndex={2}>
      <img
        src={tripOrigin}
        alt=""
        data-marker="current"
        style={{
          width: 24,
          height: 24,
          transform: 'translateY(50%)',
          objectFit: 'cover',
        }}
      />
    </AdvancedMarker>
  )
}
